<template>
  <span>
    <pu-popover v-if="popoverContent" :popover-content="popoverContent" />
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class ExtraDescription extends Vue {
  @Prop()
  extraDescription: string

  @Prop()
  extraTerms: string[]

  get popoverContent() {
    let content = ''
    if (this.extraDescription) {
      content += '<span>' + this.extraDescription + '</span>'
    }
    if (this.extraTerms && this.extraTerms.length > 0) {
      for (const term of this.extraTerms) {
        content += term + '<br>'
      }
    }
    return content
  }
}

export default toNative(ExtraDescription)
</script>
